import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sortBy } from 'lodash';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';

import DashboardCard from '../../DashboardCard';

import RatingMetric, { RatingMetricItem } from '../RatingMetric';

export default function FeedbackCategoryRatingMetric({
	data,
}: {
	data: graphql.AnalyticsFeedbackAverageRating[];
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const [modal, setModal] = useState(false);

	const sortedCategories = sortBy(
		data.map(({ category, rating }) => ({
			id: category.id,
			name: localize(category.name).text,
			rating,
		})),

		[
			(category) => {
				return !category.rating;
			},
			'name',
		],
	).filter((category) => category.rating !== null && category.rating !== undefined);

	return (
		<DashboardCard
			title={t('dashboard.metrics.feedbackAverageRating.title')}
			explanation={t('dashboard.metrics.feedbackAverageRating.explanation')}
			link={
				sortedCategories.length > 5
					? t('dashboard.metrics.feedbackAverageRating.viewAll')
					: undefined
			}
			onLinkClick={() => setModal(true)}
		>
			<RatingMetric>
				{sortedCategories.slice(0, 5).map((category) => {
					return (
						<RatingMetricItem
							key={category.id}
							title={category.name}
							value={category.rating ?? 0}
						/>
					);
				})}
			</RatingMetric>
			{modal && (
				<ModalBackground>
					<Modal>
						<ModalHeader onCancel={() => setModal(false)}>
							<ModalHeaderTitle>
								{t('dashboard.metrics.feedbackAverageRating.title')}
							</ModalHeaderTitle>
						</ModalHeader>
						<ModalContent>
							<RatingMetric>
								{sortedCategories.map((category) => {
									return (
										<RatingMetricItem
											key={category.id}
											title={category.name}
											value={category.rating ?? 0}
										/>
									);
								})}
							</RatingMetric>
						</ModalContent>
					</Modal>
				</ModalBackground>
			)}
		</DashboardCard>
	);
}
